var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMsginfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 16.5C7.05109 16.5 6.86032 16.421 6.71967 16.2803C6.57902 16.1397 6.5 15.9489 6.5 15.75V13.5H3.5C3.10218 13.5 2.72064 13.342 2.43934 13.0607C2.15804 12.7794 2 12.3978 2 12V3C2 2.60218 2.15804 2.22064 2.43934 1.93934C2.72064 1.65804 3.10218 1.5 3.5 1.5H15.5C15.8978 1.5 16.2794 1.65804 16.5607 1.93934C16.842 2.22064 17 2.60218 17 3V12C17 12.3978 16.842 12.7794 16.5607 13.0607C16.2794 13.342 15.8978 13.5 15.5 13.5H10.925L8.15 16.2825C8 16.425 7.8125 16.5 7.625 16.5H7.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsginfo);
export default __webpack_public_path__ + "static/media/msginfo.7dd5946845e56237df84707443f1cec0.svg";
export { ForwardRef as ReactComponent };